import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { HomeComponent } from './containers/home/home.component';
import { SlideModule } from '../../shared/slide/slide.module';
import { BlockModule } from '../../shared/block/block.module';
import { HomeRoutingModule } from './home-routing.module';
import { UiModule } from '../../shared/ui/ui.module';
import { TranslocoModule } from '@ngneat/transloco';
import { ScrollIndicatorComponent } from './components/scroll-indicator/scroll-indicator.component';

@NgModule({
  declarations: [HomeComponent, ScrollIndicatorComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SlideModule,
    BlockModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    UiModule,
    TranslocoModule,
  ],
  exports: [ScrollIndicatorComponent],
})
export class HomeModule {}
